/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class TopicsRoute extends Route {
  // Services
  @service
  router;

  @service
  store;

  model() {
    return this.store.findAll('goals/subject');
  }

  resetController(controller) {
    controller.reset();
  }
}
